import { Component } from '@angular/core';
import {
  NavController,
  NavParams,
  ModalController,
  AlertController,
  LoadingController
} from "ionic-angular";
import { LoginPage } from "../login/login";

import { Http } from "@angular/http";

import config from "../../config/config";


/**
 * Generated class for the BancosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-bancos',
  templateUrl: 'bancos.html',
})
export class BancosPage {
  ListadeBancos = [];
  usuario: any;
  newBanco = '';

  constructor(public navCtrl: NavController,
    private _http: Http,
    public loadingCtrl: LoadingController,
    public navParams: NavParams,
    private alertCtrl: AlertController,

    public modalCtrl: ModalController) {
  }

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.GetListadeBancos()
  }
  goToLogout() {
    sessionStorage.clear();
    this.navCtrl.setRoot(LoginPage);
  }
  GetListadeBancos() {
    this._http
      .get(config.urlAPI + "listar/bancos", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        this.ListadeBancos = res;
      })
      .catch(error => { });
  }
  removeBanco(banco) {
    let alert = this.alertCtrl.create({
      title: "Banco",
      subTitle: "Deseja realmente excluir esse banco",
      buttons: [
        {
          text: "Sim",
          handler: data => {

            this.excluirBanco(banco.id)

          }
        },
        {
          text: "Não",
          handler: data => {
          }
        }
      ]
    });
    alert.present();
  }
  addBanco() {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    let env = {
      nome:this.newBanco
    }
    this._http
    .post(config.urlAPI + "salvar/banco",env, {})
    .map(res => res.json())
    .toPromise()
    .then(res => {
      let alert = this.alertCtrl.create({
        title: "Retorno",
        subTitle: res.msg,
        buttons: [
          {
            text: "OK",
            handler: data => {
              loading.dismiss();
              this.ionViewDidLoad()
            }
          }
        ]
      })
      alert.present();
      return res
    })
    .catch(error => {
      loading.dismiss();
      return error
    });
  }
  excluirBanco(id) {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "deletar/banco/" + id, {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        let alert = this.alertCtrl.create({
          title: "Retorno",
          subTitle: res.msg,
          buttons: [
            {
              text: "OK",
              handler: data => {
                loading.dismiss();
                this.ionViewDidLoad()
              }
            }
          ]
        })
        alert.present();
        return res
      })
      .catch(error => {
        loading.dismiss();
        return error
      });
  }
}



// WEBPACK FOOTER //
// ./src/pages/bancos/bancos.ts